import React, { useState, useEffect } from "react";
import { Grid, Stack, useTheme, Chip } from "@mui/material";
// import GridDatePicker from "../../home/components/GridDatePicker";
import GridDateTimePicker from "../../home/components/GridDateTimePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { FormattedMessage } from "react-intl";
import messages from "../components/messages";
import { tokens } from "../../../assets/theme";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { CommentsDisabledOutlined } from "@mui/icons-material";
import WeekPicker from "../../../components/controls/WeekPicker";

dayjs.extend(isoWeek);

function isDateValid(dateStr) {
    return !isNaN(new Date(dateStr));
}

const getThisWeekRange = () => {
    const start = dayjs().startOf("isoWeek");
    const end = dayjs().endOf("isoWeek");
    return {
        start,
        end,
    };
};

const getLastWeekRange = () => {
    const start = dayjs().subtract(1, "week").startOf("isoWeek");
    const end = dayjs().subtract(1, "week").endOf("isoWeek");
    return {
        start,
        end,
    };
};

const DateFilter = (props) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);

    //timespan parameter to API Fetch default currentshift (24h, 72h available too)
    const [timeSpan, setTimeSpan] = useLocalStorage("timespan", "currentshift");
    //time when we changed the timespan last
    const [lastTimeSpanChange, setLastTimeSpanChange] = useLocalStorage("lastTimeSpanChange", null);

    //State to handle datepicker component visibility
    const [selectedValue, setSelectedValue] = React.useState(timeSpan);
    //State to handle datepicker component visibility
    const [showDatepicker, setShowDatePicker] = useState(timeSpan === 'manual');

    useEffect(() => {
        if (selectedValue === "week" && !props.showWeek) {
            setSelectedValue("currentshift");
            setTimeSpan("currentshift");
            setShowDatePicker(false);
        }
        if (selectedValue === "manual" && props.showWeek) {
            setSelectedValue("currentshift");
            setTimeSpan("currentshift");
            setShowDatePicker(false);
        }
    }, []);

    useEffect(() => {
        if (selectedValue === "week" && !props.showWeek) {
            setSelectedValue("currentshift");
            setTimeSpan("currentshift");
            setShowDatePicker(false);
        }
    }, [selectedValue, timeSpan]);

    const handleStartDateChange = (event) => {
        if (isDateValid(event)) {
            props.setStartDate(event);
        }
    }

    const handleEndDateChange = (event) => {
        if (isDateValid(event)) {
            props.setEndDate(event);
        }

    }

    const handleThisWeekClick = () => {
        const { start, end } = getThisWeekRange();
        handleStartDateChange(start);
        handleEndDateChange(end);
    };

    const handleLastWeekClick = () => {
        const { start, end } = getLastWeekRange();
        handleStartDateChange(start);
        handleEndDateChange(end);
    };

    const isPresetRangeSelected = (range) => {
        const currentStart = dayjs(props.startDate);
        const currentEnd = dayjs(props.endDate);

        if (!currentStart.isValid() || !currentEnd.isValid()) {
            return false;
        }

        return currentStart.isSame(range.start, "minute") && currentEnd.isSame(range.end, "minute");
    };

    const thisWeekRange = getThisWeekRange();
    const lastWeekRange = getLastWeekRange();
    const isThisWeekActive = isPresetRangeSelected(thisWeekRange);
    const isLastWeekActive = isPresetRangeSelected(lastWeekRange);

    const sendDataToParent = (data) => {
        props.onDataReceived(data);
    };

    //Change handle for radio buttons when selecting new timespan for api fetch.
    const handleChange = (event) => {
        setLastTimeSpanChange(new Date().toISOString());
        setSelectedValue(event.target.value);
        //Check if manual timespan selected, if selected then show datepickers.
        if (event.target.value !== "manual") {
            setTimeSpan(event.target.value);
            setShowDatePicker(false);
        } else {
            setShowDatePicker(true);
        }
    };

    useEffect(() => {
        sendDataToParent(selectedValue);
    }, [selectedValue]);

    const controlProps = (item) => ({
        checked: selectedValue === item,
        onChange: handleChange,
        value: item,
        name: "size-radio-button-demo",
        inputProps: { "aria-label": item },
    });

    let radiobuttons = (
        <FormControl>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
            >
                <FormControlLabel
                    value="currentShift"
                    control={<Radio {...controlProps("currentshift")} sx={{
                        color: "secondary",
                        '&.Mui-checked': {
                            color: colors.dashbordGreen[500],
                        },
                    }} />}
                    color="success"
                    label={<FormattedMessage {...messages.currentShiftFilter} />}
                />
                <FormControlLabel
                    value="prevShift"
                    control={<Radio {...controlProps("prevShift")} sx={{
                        color: "secondary",
                        '&.Mui-checked': {
                            color: colors.dashbordGreen[500],
                        },
                    }} />}
                    label={<FormattedMessage {...messages.prevShiftFilter} />}
                />
                <FormControlLabel
                    value="24h"
                    control={<Radio {...controlProps("24h")} sx={{
                        color: "secondary",
                        '&.Mui-checked': {
                            color: colors.dashbordGreen[500],
                        },
                    }} />}
                    label={<FormattedMessage {...messages.dayFilter} />}
                />
                <FormControlLabel
                    value="72h"
                    control={<Radio {...controlProps("72h")} sx={{
                        color: "secondary",
                        '&.Mui-checked': {
                            color: colors.dashbordGreen[500],
                        },
                    }} />}
                    label={<FormattedMessage {...messages.threeDayFilter} />}
                />
                {!props.hideManual && <FormControlLabel
                    value="manual"
                    control={<Radio {...controlProps("manual")} sx={{
                        color: "secondary",
                        '&.Mui-checked': {
                            color: colors.dashbordGreen[500],
                        },
                    }} />}
                    label={<FormattedMessage {...messages.manualFilter} />}
                />}
                {
                    props.showWeek && <FormControlLabel
                        value="week"
                        control={<Radio {...controlProps("week")} sx={{
                            color: "secondary",
                            '&.Mui-checked': {
                                color: colors.dashbordGreen[500],
                            },
                        }} />}
                        label={<FormattedMessage {...messages.weekFilter} />}
                    />
                }
            </RadioGroup>
        </FormControl>
    );

    let content =
        <>
            <Grid container spacing={0} sx={{ paddingTop: "0px" }}>


                <Grid item xs={12} lg={12} sx={{ justifyContent: "end", display: "flex", paddingRight: "20px" }}>
                    {radiobuttons}

                </Grid>
                {props.showWeek && timeSpan === "week" &&
                    <Grid item xs={12} lg={12} sx={{ justifyContent: "end", display: "flex", paddingRight: "20px" }}>
                        <WeekPicker
                            weeks={props.weeks}
                            setSelectedWeekStartDate={props.setSelectedWeekStartDate}
                            setSelectedWeekEndDate={props.setSelectedWeekEndDate}
                            selectedWeek={props.selectedWeek}
                            setSelectedWeek={props.setSelectedWeek} />
                    </Grid>
                }
                <Grid item xs={12} lg={12} sx={{ justifyContent: "end", display: "flex", paddingRight: "20px" }}>
                    <Stack direction="row" width="100%" spacing={2} sx={{ justifyContent: "end", flexWrap: "wrap", gap: 2 }}>
                        {showDatepicker && (<>
                            <GridDateTimePicker
                                label={<FormattedMessage {...messages.fromDate} />}
                                locale="sv"
                                maxDate={dayjs(props.endDate)}
                                minDate=""
                                onChange={handleStartDateChange}
                                date={props.startDate}
                            />
                            <GridDateTimePicker
                                label={<FormattedMessage {...messages.toDate} />}
                                locale="sv"
                                maxDate={thisWeekRange.end}
                                minDate={dayjs(props.startDate)}
                                onChange={handleEndDateChange}
                                date={props.endDate}
                            />
                            <Stack direction="row" spacing={1} sx={{ alignSelf: "center", flexWrap: "wrap", rowGap: 1 }}>
                                <Chip
                                    label={<FormattedMessage {...messages.thisWeek} />}
                                    variant={isThisWeekActive ? "filled" : "outlined"}
                                    color={isThisWeekActive ? "success" : "default"}
                                    onClick={handleThisWeekClick}
                                    sx={{
                                        cursor: "pointer",
                                        fontWeight: 600,
                                        "&.MuiChip-filled": {
                                            backgroundColor: "#799c4a",
                                            color: "#fff",
                                        },
                                    }}
                                />
                                <Chip
                                    label={<FormattedMessage {...messages.lastWeek} />}
                                    variant={isLastWeekActive ? "filled" : "outlined"}
                                    color={isLastWeekActive ? "success" : "default"}
                                    onClick={handleLastWeekClick}
                                    sx={{
                                        cursor: "pointer",
                                        fontWeight: 600,
                                        "&.MuiChip-filled": {
                                            backgroundColor: "#799c4a",
                                            color: "#fff",
                                        },
                                    }}
                                />
                            </Stack>
                        </>)}

                    </Stack>
                </Grid>
            </Grid>
        </>
    return content;
}

export default DateFilter;